import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

const pairs = ["GBPUSD", "USDCAD", "EURUSD"];
const query = pairs.map((symbol) => `symbols=${symbol}`).join("&");
const initialQuotes = {
  GBPUSD: { mid: 1.34553 },
  USDCAD: { mid: 1.37953 },
  EURUSD: { mid: 1.16137 },
};

function formatPair(symbol) {
  return `${symbol.slice(0, 3)}/${symbol.slice(3)}`;
}

function formatPrice(quote) {
  return quote?.mid ? quote.mid.toFixed(5) : "loading";
}

function ForexTickerTape() {
  const [quotes, setQuotes] = useState(initialQuotes);

  useEffect(() => {
    const controller = new AbortController();

    const loadQuotes = async () => {
      try {
        const response = await fetch(`https://biquote.io/api/latest?${query}`, {
          signal: controller.signal,
        });

        if (!response.ok) throw new Error("Ticker data request failed");

        const data = await response.json();
        setQuotes((current) => ({ ...current, ...data }));
      } catch (error) {
        if (error.name !== "AbortError") console.error(error);
      }
    };

    loadQuotes();
    const intervalId = window.setInterval(loadQuotes, 10000);

    return () => {
      controller.abort();
      window.clearInterval(intervalId);
    };
  }, []);

  return (
    <div className="h-[42px] w-full overflow-hidden text-[#05193a]">
      <Marquee autoFill gradient={false} speed={38} className="h-full">
        {pairs.map((symbol) => (
          <div
            key={symbol}
            className="ml-[12px] flex h-[14px] shrink-0 items-center gap-[6px] whitespace-nowrap border-l-2 border-[#05193a] pl-[14px]"
          >
            <span className="font-[Inter] text-[14px] font-extrabold">{formatPair(symbol)}</span>
            <span className="font-[Inter] text-[14px] font-medium">{formatPrice(quotes[symbol])}</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}

export default ForexTickerTape;
